import { render, staticRenderFns } from "./ConteudosVisuais.vue?vue&type=template&id=1aba2295"
import script from "./ConteudosVisuais.vue?vue&type=script&lang=js"
export * from "./ConteudosVisuais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports